import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { ToastContainer } from '../feedback/Toast';

export function AdminLayout() {
  const location = useLocation();
  const [navigationOpen, setNavigationOpen] = useState(false);
  const navigation = useRef<HTMLDialogElement>(null);
  useEffect(() => { setNavigationOpen(false); }, [location.key]);
  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 768px)');
    const closeOnDesktop = () => { if (desktop.matches) setNavigationOpen(false); };
    desktop.addEventListener('change', closeOnDesktop);
    return () => desktop.removeEventListener('change', closeOnDesktop);
  }, []);
  useEffect(() => {
    const dialog = navigation.current;
    if (navigationOpen && !dialog?.open) dialog?.showModal();
    if (!navigationOpen && dialog?.open) dialog.close();
  }, [navigationOpen]);
  const refreshKey = typeof location.state === 'object' && location.state !== null
    ? (location.state as { refreshAt?: number }).refreshAt ?? ''
    : '';

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="hidden md:block h-full"><Sidebar /></div>
      <dialog
        ref={navigation}
        id="admin-mobile-navigation"
        aria-label="管理后台导航"
        onClose={() => setNavigationOpen(false)}
        onClick={(event) => {
          if (event.target === event.currentTarget) {
            const bounds = event.currentTarget.getBoundingClientRect();
            if (event.clientX > bounds.right || event.clientX < bounds.left) setNavigationOpen(false);
          }
        }}
        className="fixed inset-y-0 left-0 m-0 h-dvh max-h-none w-60 max-w-[85vw] border-0 p-0 bg-white backdrop:bg-black/40 open:flex flex-col"
      >
        <div className="shrink-0 border-b border-border px-4 py-2 flex justify-end"><button type="button" className="rounded px-2 py-1 text-sm text-gray-600 focus-visible:outline-2 focus-visible:outline-primary" onClick={() => setNavigationOpen(false)}>关闭导航 ×</button></div>
        <div className="min-h-0 flex-1"><Sidebar /></div>
      </dialog>
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <TopBar navigationOpen={navigationOpen} onOpenNavigation={() => setNavigationOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-background">
          <Outlet key={`${location.pathname}${location.pathname === '/advertising/reports' ? '' : location.search}:${refreshKey}`} />
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}
